<template>
  <div class="row">
    <div class="col-md-5">
      <h1>
        {{ data.title }}
      </h1>
    </div>
    <div class="col-md-7">
      <div class="row justify-content-between">
        <div
          class="col-md-5 text-center my-3 my-md-2"
          v-for="instructor in data.instructors_obj"
          :key="instructor.id"
        >
          <div
            class="thumbnail rounded embed-responsive embed-responsive-1by1"
            :style="{
              backgroundImage: `url(${instructor.image.thumbnail})`,
            }"
          ></div>
          <h3 class="mt-3">
            {{ instructor.name }}
          </h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'StudioInstructorsPreview',
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
});
</script>

<style lang="scss" scoped>
.thumbnail {
  display: inline-block;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  max-width: 250px;
}
</style>
